import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ThingFeatureInterface} from '@app/app/shared/interfaces/thing/thing-feature.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

@Component({
  templateUrl: './park-feature-controls.html',
  selector: 'park-feature-controls'
})

export class ParkFeatureControlsComponent implements OnInit, OnDestroy {
  @Input() public features: ThingFeatureInterface[];
  @Input() public parkId: string;
  @Input() public id: string;
  @Input() public color: string;

  objectKeys = Object.keys;

  private timerSub: Subscription;

  public isRunningAuto = false;

  private MODE_AUTO = 'auto';

  private interval;

  public sortedFeatures = [];

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  ngOnInit() {
    this.sortFeatures();

    this.interval = setInterval(() => {
      this.updateFeatures();
    }, 1000);
  }

  public updateFeatures() {
    Object.keys(this.features).forEach((featureId) => {
      const feature = this.features[featureId];

      this.sortedFeatures.forEach((feat) => {
        if (featureId === feat[0]) {
          feat[1] = feature;
        }
      });
    });
  }

  public sortFeatures() {
    Object.keys(this.features).forEach((featureId) => {
      const feature = this.features[featureId];

      this.sortedFeatures.push([featureId, feature, parseInt(feature.sOr || 0, 10)]);
    });

    // sort by sort order, then by name
    this.sortedFeatures.sort((a, b) => {
      return a[2] - b[2] || a[1].nm.localeCompare(b[1].nm);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/features/features/park-feature-controls.ts